<template>
  <v-col lg12 class="text-lg-center">
    <v-pagination
      v-show="totalPage_ > 1"
      v-model="page_"
      :length="totalPage_"
      total-visible="10"
    ></v-pagination>
  </v-col>
</template>

<script>
export default {
  name: 'Paginator',
  props: {
    page: { type: Number, default: 1 },
    totalPage: { type: Number, default: 1 },
  },
  data() {
    return {
      page_: this.page,
      totalPage_: this.totalPage,
    }
  },
  watch: {
    page_: function () {
      this.$emit('page-changed', this.page_)
    },
    page: function () {
      this.page_ = this.page
    },
    totalPage: function () {
      this.totalPage_ = this.totalPage
    },
  },
}
</script>
